import { Injectable } from '@angular/core';
import { InksofteditorInterfaceData } from '@app/shared/components/inksofteditor/inksofteditor.interface';
import { AddProductPopupCompData } from '@app/shared/models/product';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StateService {

  addProductPopupdata: AddProductPopupCompData;
  _addProductPopupdataBS = new BehaviorSubject<AddProductPopupCompData>(null);

  selectedProduct: InksofteditorInterfaceData;

  // Design data for upload/preview flow
  private designData: any = null;
  private designDataForProduct: any = null;
  private selectedProductsForDesign: any = null;
  private selectedProductsForColors: any = null;
  // Multi-colorway staging state from master-product-listing, persisted here (not just held in
  // the component) so it survives the "Continue" → color-selection → Back round trip instead of
  // resetting every product's staging to a single default color.
  private stagedColorwayState: any = null;
  private colorVariantsData: any = null;
  private colorVariantsPayload: any[] = null; // Final payload for saving to API

  // Edit mode state
  private _isEditMode: boolean = false;
  private _editProductData: any = null; // Full product data for edit flow

  constructor() {
    this.addProductPopupdata;

    this._addProductPopupdataBS.next(this.addProductPopupdata);
  }

  updateAddProductPopupdata(val: AddProductPopupCompData) {
    this.addProductPopupdata = val;
    this._addProductPopupdataBS.next(this.addProductPopupdata);
  }

  updateSelectedProduct(val: InksofteditorInterfaceData) {
    this.selectedProduct = val;
  }

  // Design data methods
  setDesignData(data: any) {
    this.designData = data;
  }

  getDesignData() {
    return this.designData;
  }

  clearDesignData() {
    this.designData = null;
  }

  setDesignDataForProduct(data: any) {
    this.designDataForProduct = data;
  }

  getDesignDataForProduct() {
    return this.designDataForProduct;
  }

  clearDesignDataForProduct() {
    this.designDataForProduct = null;
  }

  setSelectedProductsForDesign(data: any) {
    this.selectedProductsForDesign = data;
  }

  getSelectedProductsForDesign() {
    return this.selectedProductsForDesign;
  }

  clearSelectedProductsForDesign() {
    this.selectedProductsForDesign = null;
  }

  setSelectedProductsForColors(data: any) {
    this.selectedProductsForColors = data;
  }

  getSelectedProductsForColors() {
    return this.selectedProductsForColors;
  }

  clearSelectedProductsForColors() {
    this.selectedProductsForColors = null;
  }

  setStagedColorwayState(data: any) {
    this.stagedColorwayState = data;
  }

  getStagedColorwayState() {
    return this.stagedColorwayState;
  }

  clearStagedColorwayState() {
    this.stagedColorwayState = null;
  }

  setColorVariantsData(data: any) {
    this.colorVariantsData = data;
  }

  getColorVariantsData() {
    return this.colorVariantsData;
  }

  clearColorVariantsData() {
    this.colorVariantsData = null;
  }

  // Color variants payload methods (final payload for API)
  setColorVariantsPayload(data: any[]) {
    this.colorVariantsPayload = data;
  }

  getColorVariantsPayload() {
    return this.colorVariantsPayload;
  }

  clearColorVariantsPayload() {
    this.colorVariantsPayload = null;
  }

  // Edit mode methods
  setEditMode(isEdit: boolean, productData?: any) {
    this._isEditMode = isEdit;
    this._editProductData = productData || null;
  }

  isEditMode(): boolean {
    return this._isEditMode;
  }

  getEditProductData(): any {
    return this._editProductData;
  }

  clearEditMode() {
    this._isEditMode = false;
    this._editProductData = null;
  }

  // Product request mode — used by product-color-selection and product-pricing-tags
  private _productRequestMode: any = null;

  setProductRequestMode(data: any) {
    this._productRequestMode = data;
  }

  getProductRequestMode(): any {
    return this._productRequestMode;
  }

  clearProductRequestMode() {
    this._productRequestMode = null;
  }
}
